// tslint:disable: max-line-length
import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { getCustomFormConfig } from './co2_custom/getCustomFormConfig';
import { DataService } from '../../services/data_service';
import { DialogKraftstoffVerbrauch } from './dialogs/DialogKraftstoffVerbrauch';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { disableKosten } from '../../helpers/showKosten';
import { filterBundle, getZaehlerMediumPreset } from './functions/filterBundle';
import { FormBtnTochtergesellschaften } from './dialogs/FormBtnTochtergesellschaften';
import { getEmissionsFaktor, getEmissionsFaktorForTid } from '../../main/functions/getEmmissionsFaktor';
import { getFormRequired } from './functions/getFormRequired';
import { hasEnergietraegerRechner } from './functions/hasEnergietraegerRechner';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { toFixedDecimal } from '../../core/formatter/formatNumber';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WForm, WFormConfig, WFormConfigItem, WFormData } from '../../core/forms/WFormFramework';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

interface DateneingabeEnergiedatenKomplexFormProps extends React.ClassAttributes<any> {
    showMode?: boolean;
    WFormId?: string;
    entity: any;
    module?: string;
    jahr: number;
    data: any;
    dataItem: any;
    standort: any;
    isFirst: boolean;
    formKey?: string;
    layout?: string;
    presetFormConfig?: WFormConfig;
    customFormConfig?: any;
    currentYear?: number;
    posFieldsHelpBeginning?: boolean;
    formSimpleValidationMsg?: any;
    selectOptionAsRadio?: boolean;
    disableFieldSelectDefaultOptions?: any;
    forceOnChange?: boolean; // Wenn true, wird onChange auch bei diff === 0 aufgerufen
    externalDescriptionElement?: JSX.Element | JSX.Element[] | string | ((formData: any) => JSX.Element);
    externalTopElement?: JSX.Element | JSX.Element[];
    customCssStyle?: any;
    hideAllFields?: boolean;
    additionalFormItems?: WFormConfigItem[];
    extraFormElementBefore?: any;
    extraFormElementAfter?: any;
    isInAssisten?: boolean;
    isPruefung?: boolean; // Flag für AssistentPruefer
    formGroupOrder?: any[];
    onValidate?: (data: any) => void;
    customOnSaveDone?: (entityName: string, values: any) => void;
    customOnDelDone?: (entityName: string, row: any) => void;
    onCurrentYearChange?: (year: number) => void;
    onChange?: (entityName: string, formValues: any, onSaveDone?: () => void, timeout?: number, field?: any) => void;
    reloadDataMonat?: (entityName: string) => void;
    announceTid?: (tid: number, wasDeleted: boolean) => void;
    onValidationStateChange?: (state: any) => void;
    getExtraElement?: (
        isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any, setValues: (values: any) => void,
        disabled?: boolean, id?: number, showMode?: boolean, styleProps?: React.CSSProperties
    ) => JSX.Element;
    getExtraElement2?: (
        isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any, setValues: (values: any) => void,
        disabled?: boolean, id?: number, showMode?: boolean
    ) => JSX.Element;
    getFunktionBtn?: (isFirst: boolean, entity: any, values: any, showMode?: boolean) => JSX.Element;
    reloadBundle?: () => void;
    bundleFilterFunc?: (bundle: any, data: any) => void;
    onFormChangeInteractive?(data: WFormData, onValueChange: (name: string, value: any) => void): void;
    onFormReady?(): void;
}

interface DateneingabeEnergiedatenKomplexFormState {
    formConfig: any;
    formValues: any;
    renderForm: boolean;
    showDialog: string;
    zaehlerTid: number;
    fahrzeugTid: number;
    standortGruppeTid: number;
    tochtergesellschaftTid: number;
    isFormSaveDone: boolean;
    configFahrzeug: any;
}

export class DateneingabeEnergiedatenKomplexForm extends
    React.Component<DateneingabeEnergiedatenKomplexFormProps, DateneingabeEnergiedatenKomplexFormState> {

    constructor(props: any) {
        super(props);
        this.state = {
            formConfig: null,
            formValues: this.props.dataItem,
            renderForm: true,
            showDialog: null,
            zaehlerTid: null,
            fahrzeugTid: null,
            standortGruppeTid: null,
            tochtergesellschaftTid: null,
            isFormSaveDone: true,
            configFahrzeug: {}
        };
        this.onFormConfigGenerated = this.onFormConfigGenerated.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.validateField = this.validateField.bind(this);
        this.getZaehlerBtn = this.getZaehlerBtn.bind(this);
        this.getFahrzeugBtn = this.getFahrzeugBtn.bind(this);
        this.getKraftstoffeVerbrauchBtn = this.getKraftstoffeVerbrauchBtn.bind(this);
        // this.getWaermeVerbrauchBtn = this.getWaermeVerbrauchBtn.bind(this);
        this.getStandortGruppeBtn = this.getStandortGruppeBtn.bind(this);
        this.getTochtergesellschaftenBtn = this.getTochtergesellschaftenBtn.bind(this);

        this.komplexFormId = props.WFormId + '-Wrapper';
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private disableKosten: boolean;
    private required: any = getFormRequired(IDs.MOD_ETOOL, this.props.entity.entity, this.props.dataItem, this.props.data);
    private validation: any;
    private currentFormTarget: any;
    private komplexFormId: string;

    componentDidMount(): void {
        this.validation = {};
        this.disableKosten = disableKosten(this.props.data);
        this.loadFormConfig();
        delete this.required.jahr;
        delete this.required.standort_tid;
        if (typeof this.props.onFormReady === 'function') {
            this.props.onFormReady();
        }
    }

    compareFormValuesForSave(ent: string, a: any, b: any) {
        if ((!a && b) || (!b && a)) {
            return 1;
        }
        let d = 0;
        Object.keys(b).forEach((k: string) => {
            if (ent === IDs.ENT_ENERGIEDATEN_STROM && (k === 'zaehler_tid' || k === 'zaehler_tid_orig')) {
                // return; // warum den Vergleich durch return überspringen, bitte erklären.
            }
            if (ent === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && (k === 'fahrzeug_tid' || k === 'fahrzeug_tid_orig')) {
                // return; // warum den Vergleich durch return überspringen, bitte erklären.
            }
            if (k.endsWith('_archiv_filename') || k.endsWith('_archiv_rawdata') || k.endsWith('_archiv_delete')) {
                // Archiv-Felder als Ausnahmen
                if (a[k] !== b[k]) {
                    d++;
                }
                return;
            }
            if (a.hasOwnProperty(k) && b.hasOwnProperty(k)
                && !a.hasOwnProperty(k + '_orig') && k !== '_formKey' && k !== 'datum'
                && !k.endsWith('_name')) {
                // if (a[k] !== b[k] && !(!a[k] && !b[k])) {
                if (a[k] !== b[k] && !((a[k] === null || a[k] === undefined) && (b[k] === null || b[k] === undefined))) {
                    // console.log(k, 'a', a[k], 'b', b[k]);
                    d++;
                }
            }
        });
        return d;
    }

    compareFormValuesForRender(a: any, b: any) {
        if ((!a && b) || (!b && a)) {
            return 1;
        }
        let d = 0;
        Object.keys(b).forEach((k: string) => {
            if (k.endsWith('_name')) {
                return;
            }
            if (a.hasOwnProperty(k) && b.hasOwnProperty(k)) {
                if (a[k] !== b[k] && !(!a[k] && !b[k])) {
                    d++;
                }
            } else {
                d++;
            }
        });
        return d;
    }

    getTochtergesellschaftenBtn() {
        const { formValues } = this.state;
        const { entity, onChange, reloadBundle } = this.props;
        const tochtergesellschaftenTid = formValues ? formValues.tochtergesellschaften || parseInt(formValues.tochtergesellschaften_name) : 0;
        let btnStyle: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplex') {
            btnStyle = { width: 20, height: 20, marginRight: 8 };
        }
        const directDialog = this.state.showDialog === 'addTochtergesellschaft';
        return <FormBtnTochtergesellschaften
            data={this.props.data}
            tochterTid={directDialog ? 0 : tochtergesellschaftenTid}
            btnDisabled={!this.state.isFormSaveDone}
            btnStyle={btnStyle}
            directDialog={directDialog}
            onDelDone={(entityName: string, row: any): void => {
                if (reloadBundle) {
                    reloadBundle();
                }
                // Beim Löschen einer Tochtergesellschaft wird diesee nicht ausgewählt.
                if ((row || {}).tid) {
                    formValues.tochtergesellschaften = null;
                    formValues.tochtergesellschaften_orig = null;
                    this.setState({ formValues });
                    if (typeof onChange === 'function') {
                        this.setState({ isFormSaveDone: false }, () => {
                            onChange(entity.entity, formValues, () => {
                                this.setState({ isFormSaveDone: true });
                            }, 0);
                        });
                    }
                }
            }}
            onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                if (reloadBundle) {
                    reloadBundle();
                }
                // Beim Anlegen einer Tochtergesellschaft wird diesee sofort ausgewählt.
                if (saveTid > 0) {
                    formValues.tochtergesellschaften = saveTid;
                    formValues.tochtergesellschaften_orig = saveTid;
                    formValues.tochtergesellschaften_name = values.name;
                    this.setState({ formValues });
                    if (typeof onChange === 'function') {
                        this.setState({ isFormSaveDone: false }, () => {
                            onChange(entity.entity, formValues, () => {
                                this.setState({ isFormSaveDone: true });
                            }, 0);
                        });
                    }
                }
            }}
            onClose={() => this.setState({ showDialog: null })}
        />;
    }

    getStandortGruppeBtn() {
        const { formValues } = this.state;
        const standortGruppeTid = formValues ? formValues.gruppe || parseInt(formValues.gruppe_name) : null;
        // console.log(formValues, standortGruppeTid);
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplex') {
            styleProps = { width: 20, height: 20, marginRight: 8 };
        }
        // Wenn das Speichern noch im Prozess ist, darf der Dialog nicht geöffnet werden
        const { isFormSaveDone } = this.state;
        if (!isFormSaveDone) {
            styleProps.backgroundColor = 'lightgray';
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {standortGruppeTid > 0 && <WActionButton
                    tooltip='Gruppe bearbeiten'
                    label='Gruppe bearbeiten'
                    action='edit'
                    key='btn_edit_gruppe'
                    styleProps={styleProps}
                    onAction={() => this.setState({ showDialog: 'editStandortGruppe', standortGruppeTid })}
                />}
                <WActionButton
                    tooltip='Neue Gruppe anlegen'
                    label='Neue Gruppe anlegen'
                    action='add'
                    key='btn_add_gruppe'
                    styleProps={styleProps}
                    disabled={!isFormSaveDone}
                    onAction={() => this.setState({ showDialog: 'editStandortGruppe', standortGruppeTid: 0 })}
                />
            </div>
        );
    }

    getZaehlerBtn(key: string) {
        const { formValues } = this.state;
        const zaehlerTid = formValues ? formValues[key] || parseInt(formValues[`${key}_name`]) : null;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplex') {
            styleProps = { marginLeft: 2, marginRight: 0 };
        }
        // Wenn das Speichern noch im Prozess ist, darf der Dialog nicht geöffnet werden
        const { isFormSaveDone } = this.state;
        if (!isFormSaveDone) {
            styleProps.backgroundColor = 'lightgray';
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {zaehlerTid > 0 &&
                    <WActionButton
                        tooltip='Zähler bearbeiten'
                        label='Zähler bearbeiten'
                        action='theme_edit'
                        key='btn_edit_zaehler'
                        styleProps={styleProps}
                        onAction={() => this.setState({
                            showDialog: key === 'zaehler2_tid' ? 'editZaehler2' : 'editZaehler', zaehlerTid
                        })}
                    />}
                <WActionButton
                    tooltip='Neuen Zähler anlegen'
                    label='Neuen Zähler anlegen'
                    action='add'
                    key='btn_add_zaehler'
                    styleProps={styleProps}
                    disabled={!isFormSaveDone}
                    onAction={() => this.setState({
                        showDialog: key === 'zaehler2_tid' ? 'editZaehler2' : 'editZaehler', zaehlerTid: 0
                    })}
                />
            </div>
        );
    }

    getFahrzeugBtn() {
        const { formValues } = this.state;
        const fahrzeugTid = formValues ? formValues.fahrzeug_tid_orig || formValues.fahrzeug_tid : null;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (this.props.layout === 'sidebysideComplex') {
            styleProps = { width: 20, height: 20, marginRight: 8 };
        }
        // Wenn das Speichern noch im Prozess ist, darf der Dialog nicht geöffnet werden
        const { isFormSaveDone } = this.state;
        if (!isFormSaveDone) {
            styleProps.backgroundColor = 'lightgray';
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {fahrzeugTid > 0 && <WActionButton
                    tooltip='Fahrzeug bearbeiten'
                    label='Fahrzeug bearbeiten'
                    action='edit'
                    key='btn_edit_fzg'
                    styleProps={styleProps}
                    onAction={() => this.setState({ showDialog: 'editFahrzeug', fahrzeugTid })}
                />}
                <WActionButton
                    tooltip='Neues Fahrzeug anlegen'
                    label='Neuen Fahrzeug anlegen'
                    action='add'
                    key='btn_add_fzg'
                    styleProps={styleProps}
                    disabled={!isFormSaveDone}
                    onAction={() => this.setState({ showDialog: 'editFahrzeug', fahrzeugTid: 0 })}
                />
            </div>
        );
    }

    getKraftstoffeVerbrauchBtn() {
        const { isFormSaveDone, formValues } = this.state;
        const label = 'Rechner';
        const noEenTraeger = formValues && !formValues.energietraeger_tid ? true : false;
        const disabled = !isFormSaveDone || noEenTraeger;
        const styleProps = this.getVerbrauchBtnStyle(disabled);
        return <div>
            <WActionButton
                label={label}
                tooltip={label}
                key='editKraftstoffeVerbrauch'
                action='calculator'
                styleProps={styleProps}
                disabled={!isFormSaveDone}
                onAction={() => {
                    if (noEenTraeger) {
                        alert('Bitte erst einen Kraftstoff wählen.');
                    } else {
                        this.checkParentTid(() => this.setState({ showDialog: 'editKraftstoffeVerbrauch' }));
                    }
                }}
            />
        </div>;
    }

    getVerbrauchBtnStyle(disabled = false) {
        const { layout } = this.props;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };
        if (layout === 'sidebysideComplex') {
            styleProps = { ...styleProps, ...{ width: 20, height: 20, marginRight: 8 } };
        }
        if (disabled) {
            styleProps.backgroundColor = 'lightgray';
            styleProps.cursor = 'not-allowed';
        }
        return styleProps;
    }

    // Wir müssen zuerst sichern, dass es eine tid gibt, die dann als parent_tid dient.
    checkParentTid(callback: () => void) {
        const { entity } = this.props;
        const { formValues } = this.state;
        if (!formValues.tid || formValues.tid === 0) {
            this.dataService.saveData(entity.entity, formValues, null, false, (suc: boolean, saveTid: number) => {
                if (suc && saveTid > 0) {
                    // console.log(saveTid);
                    formValues.tid = saveTid;
                    this.setState({ formValues }, callback);
                }
            }, IDs.MOD_ETOOL);
        } else {
            callback();
        }
    }

    isFormEmpty(d: any) {
        const { entity } = this.props;
        const entName = entity.entity;
        let e = true;
        Object.keys(d).forEach((k: string) => {
            if (entName === IDs.ENT_ENERGIEDATEN_WAERME && k === 'co2_emissionen_orig' &&
                (d.energietraeger_tid !== 7 /*Fernwärme*/ && d.energietraeger_tid !== 21 /*Fernkälte*/)) {
                // Keine Fernwärme & Fernkälte, CO₂-Emissionen (nun Emissionsfaktor) ignorieren
                return;
            } else if (
                k !== 'datum' && k !== 'abrechnungszeitraum_bis' && k !== 'abrechnungszeitraum_von' && k !== 'abrechnungstage'
                && k !== 'gebaeude_tid' && k !== 'jahr' && k !== 'monat' && k !== 'energietraeger_tid_name' && k !== 'standort_tid'
                && k !== 'standort_tid_orig' && k !== 'standort_tid_name' && k !== 'anlagen_eigenstrom_typ_tid'
                && k !== 'anlagen_eigenstrom_typ' && k !== 'tid' && k !== '_formKey' && k !== 'mandant'
            ) {
                if (d[k] && d[k] !== '' && d[k] !== 0) {
                    // console.log(k, d[k]);
                    e = false;
                }
            }
        });
        return e;
    }

    loadFormConfig() {
        if (this.props.presetFormConfig) {
            this.onFormConfigGenerated(this.props.presetFormConfig);
        } else {
            const struct_tool = new StructureTool(IDs.MOD_ETOOL, this.props.data);
            struct_tool.generateFormConfig(this.props.entity.entity, this.onFormConfigGenerated);
        }
    }

    onFormChange(formData: any, item?: any): void {
        const { data, entity, onChange, announceTid } = this.props;
        const { formConfig } = this.state;
        const entityName = entity.entity;
        // valuesNew
        onFormChangeUniversal(entity.entity, formData, this, data);
        const valuesNew = formData.getAllValues();

        if (entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
            this.validCo2Emissionen(valuesNew, formConfig);
        }

        if (entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
            this.validCo2EmissionenKraftstoffe(valuesNew, formConfig);
            // this.validKraftstoffe(valuesNew, formConfig);
        }

        if (!this.currentFormTarget) {
            // console.log('onFormChange', 'Datenänderung wegen Vorbelegungen', 'Übersprungen!');
            // Wenn es keinen currentFormTarget gibt, wurde die Datenänderung nicht vom User gemacht.
            // Deswegen triggern onFormChange nicht, um leere Datensätze zu vermeiden, lassen aber Validation und onFormChangeUniversal.
            return;
        }

        if (this.isFormEmpty(valuesNew)) {
            // delete item
            if (valuesNew.tid > 0) {
                console.log('Form leer! -> delData', entityName, valuesNew.tid);
                this.dataService.delData(entityName, IDs.MOD_ETOOL, { tid: valuesNew.tid }, {},
                    () => {
                        if (typeof this.props.onValidate === 'function') {
                            Object.keys(this.validation || {}).forEach((field: string) => this.validation[field] = null);
                            this.props.onValidate({
                                entity: this.props.entity.entity,
                                jahr: this.props.jahr,
                                tid: valuesNew.tid || null,
                                fields: this.validation
                            });
                        }
                        this.triggerService.fire('reload', entityName);
                        if (announceTid) {
                            announceTid(valuesNew.tid, true);
                        }
                        valuesNew.tid = 0;
                    });
            }
        } else {
            // valuesOld
            const valuesOld = Array.isArray(data[entityName]) && data[entityName].find((d: any) => d.tid === valuesNew.tid);
            // compare
            const diff = this.compareFormValuesForSave(entityName, valuesOld, valuesNew);
            // console.log(valuesOld, valuesNew, diff);
            if (diff > 0 || this.props.forceOnChange) {
                if (typeof onChange === 'function') {
                    this.setState({ isFormSaveDone: false }, () => {
                        const timeout = this.getOnFormChangeTimeout(entityName, valuesOld, valuesNew);
                        onChange(entity.entity, valuesNew, () => {
                            if (this.props.customOnSaveDone) {
                                this.props.customOnSaveDone(entity.entity, valuesNew);
                            }
                            this.setState({ isFormSaveDone: true });
                        }, timeout, item);
                    });
                }
            }
        }
        this.setState({ formValues: valuesNew, renderForm: true });
    }

    getOnFormChangeTimeout(entityName: string, valOld: any, valNew: any) {
        // console.log(entityName, valOld, valNew);
        let timeout;
        if (entityName === IDs.ENT_ENERGIEDATEN_STROM || entityName === IDs.ENT_ENERGIEDATEN_WAERME) {
            // Beim Wechseln von Abrechnungsmodus soll der Monatsrechner bei Strom und Wärme sofort erscheinen
            if (
                (!valOld && valNew && valNew.abrechnungsmodus === 2) ||
                (valOld && valNew && valOld.abrechnungsmodus !== valNew.abrechnungsmodus)
            ) {
                timeout = 0;
            }
        }
        // console.log(valOld, valNew, timeout);
        return timeout;
    }

    validCo2Emissionen(values: any, formConfig: any) {
        // Siehe auch onFormChangeWaerme()
        const feldCo2 = formConfig.getItem('co2_emissionen');
        if (feldCo2) {
            if (values.energietraeger_tid === 7 /*Fernwärme*/ || values.energietraeger_tid === 21 /*Fernkälte*/ || values.energietraeger_tid === 11 /*Strom*/ || values.energietraeger_tid === 12 /*Sonstige Wärmeträger*/) {
                feldCo2.disabled = false;
                delete (values.co2_emissionen_orig);
            } else {
                feldCo2.disabled = true;
                if (!values.energietraeger_tid /*keine Auswahl*/) {
                    values.co2_emissionen = null;
                    values.co2_emissionen_orig = null;
                }
            }
        }
    }

    validCo2EmissionenKraftstoffe(values: any, formConfig: any) {
        const feldCo2 = formConfig.getItem('co2_emissionen');
        if (feldCo2) {
            if (values.energietraeger_tid === 7 /*Ladestrom*/) {
                feldCo2.disabled = false;
                delete (values.co2_emissionen_orig);
            } else {
                feldCo2.disabled = true;
                values.co2_emissionen = null;
                values.co2_emissionen_orig = null;
            }
        }
    }

    public onFormConfigGenerated(formConfig: WFormConfig) {
        if (!formConfig) {
            return;
        }
        if (this.props.customFormConfig) {
            const cf = this.props.customFormConfig;
            Object.keys(cf).forEach((key: string) => {
                const idx = formConfig.items.findIndex((it: any) => (it.key || it.id) === key);
                if (idx >= 0) {
                    if (cf[key].label) {
                        formConfig.items[idx].label = cf[key].label;
                    }
                    if (cf[key].hasOwnProperty('required')) {
                        formConfig.items[idx].required = cf[key].required;
                    }
                    if (cf[key].hasOwnProperty('readonly')) {
                        formConfig.items[idx].readonly = cf[key].readonly;
                    }
                    if (cf[key].hasOwnProperty('hidden')) {
                        formConfig.items[idx].hidden = cf[key].hidden;
                    }
                    if (cf[key].radio) {
                        formConfig.items[idx].radio = true;
                    }
                    if (cf[key].disable_default) {
                        formConfig.items[idx].disable_default = true;
                    }
                    if (cf[key].show) {
                        formConfig.items[idx].show = true;
                    }
                    if (cf[key].hidden_input) {
                        if (this.props.isInAssisten) {  // Im Assistenten ganz ausblenden
                            formConfig.items[idx].hidden = true;
                        } else {
                            formConfig.items[idx].hidden_input = true;
                        }
                    }
                    if (cf[key].hidden_msg) {
                        formConfig.items[idx].hidden_msg = cf[key].hidden_msg;
                    }
                    if (cf[key].placeholder) {
                        formConfig.items[idx].placeholder = cf[key].placeholder;
                    }
                    if (cf[key].bundle_output) {
                        formConfig.items[idx].bundle_output = cf[key].bundle_output;
                    }
                    if (cf[key].bundle_text) {
                        formConfig.items[idx].bundle_text = cf[key].bundle_text;
                    }
                    if (typeof cf[key].sysTxtKeyHinweis === 'string') {
                        formConfig.items[idx].sysTxtKeyHinweis = cf[key].sysTxtKeyHinweis;
                    }
                    if (cf[key].validMsgStyle) {
                        formConfig.items[idx].validMsgStyle = cf[key].validMsgStyle;
                    }
                    if (typeof cf[key].showFullValidMsg === 'boolean') {
                        formConfig.items[idx].showFullValidMsg = cf[key].showFullValidMsg;
                    }
                    let eventComponent: any = {};
                    if (cf[key].event_handler) {
                        formConfig.items[idx].event_handler = cf[key].event_handler(this, (data: any) => {
                            if (Object.keys((data || {}).state || {}).length) {
                                setTimeout(() => this.setState(data.state));
                            }
                            eventComponent[idx] = data || {};
                        });
                    }
                    if (cf[key].custom_component) {
                        formConfig.items[idx].custom_component = (setValue?: (value: any) => void, elementRef?: any) =>
                            !cf[key].hidden && !cf[key].hidden_input && cf[key].custom_component(this, eventComponent[idx], (data: any) => {
                                if (Object.keys((data || {}).state || {}).length) {
                                    setTimeout(() => this.setState(data.state));
                                }
                            }
                            );
                    }
                }
            });
        }
        if (this.props.entity.entity === IDs.ENT_UNTERNEHMENSDATEN) {
            const tochterIdx = formConfig.items.findIndex((i: any) => i.key === 'tochtergesellschaften');
            if (tochterIdx >= 0) {
                formConfig.items[tochterIdx].custom_component = this.getTochtergesellschaftenBtn;
                formConfig.items[tochterIdx].event_handler = this.getFormEventHandler('addTochtergesellschaft');
            }
        }
        if (this.props.entity.entity === IDs.ENT_STANDORT) {
            const gruppeIdx = formConfig.items.findIndex((i: any) => i.key === 'gruppe');
            if (gruppeIdx >= 0) {
                formConfig.items[gruppeIdx].custom_component = this.getStandortGruppeBtn;
                formConfig.items[gruppeIdx].event_handler = this.getFormEventHandler('standortGruppe_tid');
            }
            const tochterIdx = formConfig.items.findIndex((i: any) => i.key === 'tochtergesellschaften');
            if (tochterIdx >= 0) {
                formConfig.items[tochterIdx].custom_component = this.getTochtergesellschaftenBtn;
                formConfig.items[tochterIdx].event_handler = this.getFormEventHandler('addTochtergesellschaft');
            }
        }
        if (this.props.entity.entity === IDs.ENT_ENERGIEDATEN_STROM ||
            this.props.entity.entity === IDs.ENT_ENERGIEDATEN_WAERME/* ||
            this.props.entity.entity === IDs.ENT_ENERGIEDATEN_WASSER*/) {
            const zaehlerIdx = formConfig.items.findIndex((i: any) => i.key === 'zaehler_tid');
            if (zaehlerIdx >= 0) {
                formConfig.items[zaehlerIdx].custom_component = (setValue?: (value: any) => void, elementRef?: any) =>
                    this.getZaehlerBtn('zaehler_tid');
                formConfig.items[zaehlerIdx].event_handler = this.getFormEventHandler('zaehler_tid');
            }
            const zaehler2Idx = formConfig.items.findIndex((i: any) => i.key === 'zaehler2_tid');
            if (zaehler2Idx >= 0) {
                formConfig.items[zaehler2Idx].custom_component = (setValue?: (value: any) => void, elementRef?: any) =>
                    this.getZaehlerBtn('zaehler2_tid');
            }
        }
        if (this.props.entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
            const fahrzeugIdx = formConfig.items.findIndex((i: any) => i.key === 'fahrzeug_tid');
            if (fahrzeugIdx >= 0) {
                formConfig.items[fahrzeugIdx].custom_component = this.getFahrzeugBtn;
                formConfig.items[fahrzeugIdx].event_handler = this.getFormEventHandler('fahrzeug_tid');
            }
        }
        if (this.props.entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
            const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
            if (verbrauchIdx >= 0) {
                formConfig.items[verbrauchIdx].custom_component = this.getKraftstoffeVerbrauchBtn;
            }
        }
        if (this.props.entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
            const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
            if (verbrauchIdx >= 0) {
                // WKETOOL-160: Die Schaltfläche "Monatsverbräuche" wird weiter oben angezeigt
                // formConfig.items[verbrauchIdx].custom_component = this.getWaermeVerbrauchBtn;
            }
        }

        if (this.props.additionalFormItems) {
            formConfig.items = [...formConfig.items, ...this.props.additionalFormItems];
        }
        this.setState({ formConfig });
    }

    initFormData() {
        const { formValues } = this.state;
        const formData = new WFormData();
        formData.setValue('tid', 0);
        formData.setValue('jahr', this.props.jahr);
        formData.setValue('abrechnungszeitraum_von', new Date(this.props.jahr + '-01-01').getTime() / 1000);
        formData.setValue('abrechnungszeitraum_bis', new Date(this.props.jahr + '-12-31').getTime() / 1000);
        if (formValues) {
            const itemCopy = { ...formValues };
            Object.keys(formValues).forEach((key: string) => {
                if (key.slice(-5) === '_orig') {
                    itemCopy[key.slice(0, -5) + '_name'] = itemCopy[key.slice(0, -5)];
                    itemCopy[key.slice(0, -5)] = formValues[key];
                }
            });
            formData.overwriteAllValues(itemCopy);
        }
        return formData;
    }

    render(): JSX.Element {
        const { showMode, entity, WFormId, getExtraElement, getExtraElement2, getFunktionBtn } = this.props;
        const { formValues, formConfig } = this.state;

        if (!formConfig) {
            return <div>Lade Konfiguration ...</div>;
        }

        const preset: any = {};
        if (this.props.standort) {
            preset.standort_tid = this.props.standort.tid;
        }

        const bundleFiltered = filterBundle(entity.entity, entity.bundle, this.props.data, this.props.standort);
        if (this.props.bundleFilterFunc) {
            this.props.bundleFilterFunc(bundleFiltered, this.props.data);
        }

        const { showToolBtn, disableToolBtn, showToolBtn2, disableToolBtn2 } = this.setFormConfig();
        const formData = this.initFormData();

        const extraElement = typeof getExtraElement === 'function' &&
            getExtraElement(this.props.isFirst, this.props.standort, this.props.jahr, entity, formValues, (values: any) => {
                Object.keys(values).forEach((k: any) => {
                    const val = typeof values[k] === 'string' || typeof values[k] === 'number' ? values[k] : '';
                    formData.setValue(k, val);
                });
                this.setState({ renderForm: false }, () => this.onFormChange(formData));
            }, disableToolBtn, null, showMode);
        // WKETOOL-160: Die Schaltfläche "Monatsverbräuche" wird weiter oben angezeigt
        const extraElementAfter = showToolBtn && (entity.entity === IDs.ENT_ENERGIEDATEN_STROM || entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) &&
            extraElement && { abrechnungsmodus: extraElement };

        const extraElement2 = typeof getExtraElement2 === 'function' &&
            getExtraElement2(this.props.isFirst, this.props.standort, this.props.jahr, entity, formValues, (values: any) => {
                Object.keys(values).forEach((k: any) => {
                    const val = typeof values[k] === 'string' || typeof values[k] === 'number' ? values[k] : '';
                    formData.setValue(k, val);
                });
                this.setState({ renderForm: false }, () => this.onFormChange(formData));
            }, disableToolBtn2, 1, showMode);
        const extraElementAfter2 = showToolBtn2 && entity.entity === IDs.ENT_ENERGIEDATEN_WAERME &&
            extraElement2 && { bemerkung: extraElement2 };

        const funktionBtn = typeof getFunktionBtn === 'function' && getFunktionBtn(this.props.isFirst, entity, formValues, showMode);

        const hasBeraterZugriff: boolean = entity.entity === IDs.ENT_KONFIGURATION && (this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.berater_zugriff_orig === 1 || param.berater_zugriff === 1);
        const extraFormElementAfter = this.props.extraFormElementAfter ?
            {
                ...this.props.extraFormElementAfter,
                ...(entity.entity === IDs.ENT_KONFIGURATION && !hasBeraterZugriff
                    ? { externer_berater: <div style={{ height: 20 }} /> }
                    : {}
                )
            } : {};

        // Update formValues
        const formValuesNew = formData.getAllValues();
        const valDiff = this.compareFormValuesForRender(this.state.formValues, formValuesNew);
        if (valDiff > 0) {
            this.setState({ formValues: formValuesNew });
        }
        const hiddenFields = ['gebaeude_tid', 'monat', 'jahr'];
        if (entity.entity !== IDs.ENT_STANDORT) {
            hiddenFields.push('standort_tid');
        }
        if (entity.entity === IDs.ENT_ENERGIEDATEN_WASSER) {
            // console.log('Wasser 2 ', formData, this.props.formKey, this.props.WFormId);
        }
        return (
            <div
                id={this.komplexFormId}
                onClick={(event: any) => {
                    this.props.onCurrentYearChange && this.props.onCurrentYearChange(this.props.jahr);
                    this.currentFormTarget = event.target;
                }}
                onChange={(event: any) => this.currentFormTarget = event.target}
            >
                {this.state.renderForm &&
                    <WForm
                        id={WFormId}
                        entity={entity.entity}
                        module={this.props.module}
                        titel={'Formular'}
                        layout={this.props.layout || 'sidebysideComplex'}
                        config={formConfig}
                        dataIn={formData}
                        hideAllFields={this.props.hideAllFields}
                        standortSelected={this.props.standort}
                        readOnly={false}
                        showMode={showMode}
                        bundle={bundleFiltered}
                        hiddenFormFields={hiddenFields}
                        preset={preset}
                        onFormChange={this.onFormChange}
                        validateField={(key: string, value: any, data: any, onValueChange) =>
                            this.validateField(entity.entity, key, value, data, onValueChange)}
                        onFormSave={(formItem: WFormData) => {
                            if (this.props.customOnSaveDone) {
                                this.props.customOnSaveDone(entity.entity, formItem.getAllValues());
                            }
                        }}
                        onFormCancel={() => { }}
                        showFieldsHelp={true}
                        globalData={this.props.data}
                        posFieldsHelpBeginning={this.props.posFieldsHelpBeginning}
                        customCssStyle={{
                            formcontainer: {
                                height: 'unset',
                                minHeight: 'unset',
                                marginTop: 0
                            },
                            formField: {
                                seperate_abrechnung_emobil_strom: {
                                    minHeight: 41,
                                    classInput: { display: 'flex', paddingTop: 0 },
                                    classSelect: { margin: 'auto' }
                                },
                            },
                            ...this.props.customCssStyle
                        }}
                        hideCancel={true}
                        hideSave={true}
                        hideTitel={true}
                        hideLabels={!this.props.isFirst}
                        disableFieldSelectDefaultOptions={this.props.disableFieldSelectDefaultOptions}
                        selectOptionAsRadio={this.props.selectOptionAsRadio}
                        onValidationStateChange={this.props.onValidationStateChange}
                        enableDidUpdateCheck={
                            entity.entity === IDs.ENT_ENERGIEDATEN_WAERME || entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE
                        }
                        simpleValidationMsg={this.props.formSimpleValidationMsg}
                        onFormChangeInteractive={this.props.onFormChangeInteractive}
                        externalElement={
                            <div>
                                {showToolBtn && entity.entity !== IDs.ENT_ENERGIEDATEN_STROM
                                    && entity.entity !== IDs.ENT_ENERGIEDATEN_WAERME && extraElement
                                }
                                {funktionBtn}
                            </div>
                        }
                        extraElementBefore={this.props.extraFormElementBefore}
                        extraElementAfter={{ ...extraElementAfter, ...extraElementAfter2, ...extraFormElementAfter }}
                        externalDescriptionElement={this.props.externalDescriptionElement}
                        externalTopElement={this.props.externalTopElement}
                        valueFieldSelectDefaultOptions={
                            entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE ? { fahrzeug_tid: 'keine Einzelerfassung' } : null
                        }
                        isPruefung={this.props.isPruefung}
                        groupOrder={this.props.formGroupOrder}
                        useTheme={0}
                    // layout2='assistent'
                    />
                }
                {this.state.showDialog && this.renderDialog()}
            </div>
        );
    }

    setFormConfig() {
        const { entity, getExtraElement, getExtraElement2, isInAssisten } = this.props;
        const { formValues, formConfig } = this.state;
        const simpleModus: boolean = (this.props.data[IDs.ENT_KONFIGURATION] || []).some((c: any) => c.co2_fussabdruck_modus === 'simple');
        let showToolBtn = false;
        let disableToolBtn = false;
        let showToolBtn2 = false;
        let disableToolBtn2 = false;

        const updateFormConfig = (formConfig: any) => {
            if (JSON.stringify(formConfig) !== JSON.stringify(this.state.formConfig)) {
                this.setState({ formConfig });
            }
        };

        // if ((typeof getExtraElement === 'function' || (isInAssisten && entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE)) && formValues) {
        if (formConfig && formValues) {
            if (entity.entity === IDs.ENT_STANDORT /*|| entity.entity === IDs.XXXXXXXX */) {
                // Die Entitäten oben können ohne weitere Anpassung erweitert werden.
                let doUpdateState = false;
                const customFormConfig = getCustomFormConfig(entity.entity, formValues, this.props.data);
                Object.keys(customFormConfig).forEach((field: string) => {
                    const idx = formConfig.items.findIndex((i: any) => i.key === field);
                    if (idx >= 0) {
                        Object.keys(customFormConfig[field]).forEach((attr: string) => {
                            if (formConfig.items[idx] && formConfig.items[idx][attr] !== customFormConfig[field][attr]) {
                                formConfig.items[idx][attr] = customFormConfig[field][attr];
                                doUpdateState = true;
                            }
                        });
                    }
                })
                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
                let doUpdateState = false;
                const hasAbrechnungen: boolean = (this.props.data[IDs.ENT_OEL_ABRECHNUNG] || []).some((r: any) =>
                    formValues.tid > 0
                    && (typeof formValues.standort_tid_orig === 'number' && r.standort_tid_orig === formValues.standort_tid_orig)
                    && (typeof formValues.energietraeger_tid_orig === 'number' && r.energietraeger_tid_orig === formValues.energietraeger_tid_orig)
                    && (typeof formValues.einheit_tid_orig === 'number' && r.einheit_tid_orig === formValues.einheit_tid_orig)
                );
                const energietraeger_tid = typeof formValues.energietraeger_tid_orig === 'number' ? formValues.energietraeger_tid_orig : formValues.energietraeger_tid;
                const hasER = hasEnergietraegerRechner({ energietraeger_tid });
                const istMonats = formValues.abrechnungsmodus === 2; // Monatsrechnungen
                // Wird "Monatsrechnungen" nicht ausgewählt, und kein EnergietraegerRechner gestellt, sollte der Rechner Button deaktiviert werden.
                disableToolBtn = !hasER && !istMonats;

                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                const azVonIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_von');
                const azBisIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_bis');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const co2_emissionenIdx = formConfig.items.findIndex((i: any) => i.key === 'co2_emissionen');
                const abrechnungsmodusIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungsmodus');

                if (dateiIdx >= 0) {
                    if (hasER && !istMonats) {
                        if (formConfig.items[dateiIdx].hidden_input !== hasAbrechnungen) {
                            doUpdateState = true;
                            formConfig.items[dateiIdx].hidden = hasAbrechnungen ? !!isInAssisten : false;
                            formConfig.items[dateiIdx].hidden_input = hasAbrechnungen;
                            formConfig.items[dateiIdx].hidden_msg = hasAbrechnungen ?
                                isInAssisten ? 'siehe Berechnung Brennstoff-Verbrauch' : 'siehe Rechner'
                                : undefined;
                        }
                    } else {
                        if (formConfig.items[dateiIdx].hidden_input !== istMonats) {
                            doUpdateState = true;
                            formConfig.items[dateiIdx].hidden = istMonats ? !!isInAssisten : false;
                            formConfig.items[dateiIdx].hidden_input = istMonats;
                            formConfig.items[dateiIdx].hidden_msg = istMonats ?
                                isInAssisten ? 'siehe Monatsverbräuche' : 'siehe Rechner'
                                : undefined;
                        }
                    }
                    if (isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                        doUpdateState = true;
                        formConfig.items[dateiIdx].hidden = !formValues.tid;
                    }
                }
                if (azVonIdx >= 0 && formConfig.items[azVonIdx].readonly !== istMonats) {
                    // Wird "Monatsrechnungen" ausgewählt, sollte der Abrechnungszeitraum ausgegraut werden.
                    doUpdateState = true;
                    formConfig.items[azVonIdx].readonly = istMonats;
                }
                if (azBisIdx >= 0 && formConfig.items[azBisIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[azBisIdx].readonly = istMonats;
                }
                if (verbrauchIdx >= 0 && formConfig.items[verbrauchIdx].readonly !== (istMonats && !hasER)) {
                    doUpdateState = true;
                    formConfig.items[verbrauchIdx].readonly = (istMonats && !hasER);
                }
                if (this.disableKosten && kostenIdx >= 0 && !formConfig.items[kostenIdx].hidden) {
                    doUpdateState = true;
                    formConfig.items[kostenIdx].hidden = true;
                } else if (!this.disableKosten && kostenIdx >= 0 && formConfig.items[kostenIdx].readonly !== (istMonats && !hasER)) {
                    doUpdateState = true;
                    formConfig.items[kostenIdx].readonly = (istMonats && !hasER);
                }
                if (co2_emissionenIdx >= 0 && formConfig.items[co2_emissionenIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[co2_emissionenIdx].readonly = istMonats;
                    if ([7, 11, 12, 21].indexOf(formValues.energietraeger_tid_orig) !== -1) {
                        // {7} Fernwärme, {11} Strom, {12} Sonstige Wärmeträger, {21} Fernkälte
                        // Siehe auch validCo2Emissionen() & onFormChangeWaerme()
                        // Suche * 1000000000
                        const emissionsfaktor: number = getEmissionsFaktorForTid(this.props.data, this.props.jahr, formValues.energietraeger_tid_orig);
                        if (emissionsfaktor > 0) {
                            if (formValues.einheit_tid_orig === 7 /* MWh */) {
                                formConfig.items[co2_emissionenIdx].placeholder = toFixedDecimal(emissionsfaktor * 1000000000, 0);
                            } else {
                                formConfig.items[co2_emissionenIdx].placeholder = toFixedDecimal(emissionsfaktor * 1000000, 3);
                            }
                        } else {
                            formConfig.items[co2_emissionenIdx].required = true;
                        }
                    } else {
                        if (this.props.isInAssisten) {
                            // Im Assistenten ganz ausblenden
                            formConfig.items[co2_emissionenIdx].hidden = true;
                        } else {
                            formConfig.items[co2_emissionenIdx].hidden_input = true;
                        }
                    }
                }
                if (abrechnungsmodusIdx >= 0 && formConfig.items[abrechnungsmodusIdx].hidden_input !== hasER) {
                    // Eingabe von Jahres-/Monatsabrechnung beim hasEnergietraegerRechner ausblenden
                    doUpdateState = true;
                    formConfig.items[abrechnungsmodusIdx].hidden_input = hasER;
                }

                const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
                if (modul === 'steuer') {
                    // keine
                } else if (simpleModus) {
                    const hiddenFields = ['abrechnungsart', 'abrechnungstage', 'zaehler_tid', 'waerme_dritte'];
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }

                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_STROM) {
                let doUpdateState = false;
                const bereich_key: string = this.apiService.getBereichKey();
                const istMonats = formValues.abrechnungsmodus === 2; // Monatsrechnungen
                // Wird "Monatsrechnungen" nicht ausgewählt, sollte der Rechner Button deaktiviert werden.
                disableToolBtn = !istMonats;

                const azVonIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_von');
                const azBisIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_bis');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch_kwh');
                const kosten_nettoIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten_netto');
                const co2_emissionenIdx = formConfig.items.findIndex((i: any) => i.key === 'co2_emissionen');
                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                const spitzenlastIdx = formConfig.items.findIndex((i: any) => i.key === 'spitzenlast');

                if (dateiIdx >= 0 && formConfig.items[dateiIdx].hidden_input !== istMonats) {
                    // Wird "Monatsrechnungen" ausgewählt, sollte die Standardzeile "Datei-wählen" deaktiviert werden.
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = istMonats ? !!isInAssisten : false;
                    formConfig.items[dateiIdx].hidden_input = istMonats;
                    formConfig.items[dateiIdx].hidden_msg = istMonats
                        ? isInAssisten ? 'siehe Monatsverbräuche' : 'siehe Rechner'
                        : undefined;
                }
                if (dateiIdx >= 0 && isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = !formValues.tid;
                }
                if (azVonIdx >= 0 && formConfig.items[azVonIdx].readonly !== istMonats) {
                    // Wird "Monatsrechnungen" ausgewählt, sollte der Abrechnungszeitraum ausgegraut werden.
                    doUpdateState = true;
                    formConfig.items[azVonIdx].readonly = istMonats;
                }
                if (azBisIdx >= 0 && formConfig.items[azBisIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[azBisIdx].readonly = istMonats;
                }
                if (verbrauchIdx >= 0 && formConfig.items[verbrauchIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[verbrauchIdx].readonly = istMonats;
                }
                if (this.disableKosten && kosten_nettoIdx >= 0 && !formConfig.items[kosten_nettoIdx].hidden) {
                    doUpdateState = true;
                    formConfig.items[kosten_nettoIdx].hidden = true;
                } else if (!this.disableKosten && kosten_nettoIdx >= 0 && formConfig.items[kosten_nettoIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[kosten_nettoIdx].readonly = istMonats;
                }
                if (co2_emissionenIdx >= 0 && formConfig.items[co2_emissionenIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[co2_emissionenIdx].readonly = istMonats;
                    let emissionsfaktor: number = getEmissionsFaktor(this.props.data, '', this.props.jahr, 'strom_mix');
                    emissionsfaktor = +emissionsfaktor > 0 ? emissionsfaktor * 1000000 : emissionsfaktor;
                    if (emissionsfaktor) {
                        formConfig.items[co2_emissionenIdx].placeholder = emissionsfaktor;
                    }
                }
                if (spitzenlastIdx >= 0 && formConfig.items[spitzenlastIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[spitzenlastIdx].readonly = istMonats;
                }

                const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
                if (modul === 'steuer') {
                    // keine
                } else if (simpleModus || bereich_key !== 'handwerk') {
                    let hiddenFields: Array<string> = [];
                    hiddenFields = simpleModus
                        ? ['abrechnungsart', 'abrechnungstage', 'zaehler_tid', 'spitzenlast', 'seperate_abrechnung_emobil_strom', 'strom_dritte']
                        : (bereich_key !== 'sonstige' && modul !== 'cfm' ? ['strom_dritte'] : []);
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }

                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
                let doUpdateState = false;
                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                if (dateiIdx >= 0 && isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = !formValues.tid;
                }
                if (simpleModus) {
                    const hiddenFields = ['abrechnungstage', 'eigenverbrauch_kwh', 'eigenverbrauchsquote'];
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }
                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
                let doUpdateState = false;
                const istMonats = (this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE] || []).some((r: any) =>
                    formValues.tid > 0 && r.parent_tid === formValues.tid
                );
                const hasFzg = formValues.fahrzeug_tid > 0 || formValues.fahrzeug_tid_orig > 0;
                const modul: string = (this.props.data || {}).MODUL_SELECTED || null;

                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                const azVonIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_von');
                const azBisIdx = formConfig.items.findIndex((i: any) => i.key === 'abrechnungszeitraum_bis');
                const verbrauchIdx = formConfig.items.findIndex((i: any) => i.key === 'verbrauch');
                const kostenIdx = formConfig.items.findIndex((i: any) => i.key === 'kosten');
                const laufleistungIdx = formConfig.items.findIndex((i: any) => i.key === 'laufleistung');
                const energietraegerIdx = formConfig.items.findIndex((i: any) => i.key === 'energietraeger_tid');
                const co2_emissionenIdx = formConfig.items.findIndex((i: any) => i.key === 'co2_emissionen');

                if (energietraegerIdx >= 0 && !formConfig.items[energietraegerIdx].disabled && hasFzg) {
                    formConfig.items[energietraegerIdx].readonly = true;
                }
                if (dateiIdx >= 0 && formConfig.items[dateiIdx].hidden_input !== istMonats) {
                    // hat "Monatsrechnungen", sollte die Standardzeile "Datei-wählen" deaktiviert werden.
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = istMonats ? !!isInAssisten : false;
                    formConfig.items[dateiIdx].hidden_input = istMonats;
                    formConfig.items[dateiIdx].hidden_msg = istMonats ? 'siehe Rechner' : undefined;
                }
                if (dateiIdx >= 0 && isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = !formValues.tid;
                }
                if (azVonIdx >= 0 && formConfig.items[azVonIdx].readonly !== istMonats) {
                    // hat "Monatsrechnungen", sollte der Abrechnungszeitraum ausgegraut werden.
                    doUpdateState = true;
                    formConfig.items[azVonIdx].readonly = istMonats;
                }
                if (azBisIdx >= 0 && formConfig.items[azBisIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[azBisIdx].readonly = istMonats;
                }
                if (verbrauchIdx >= 0 && formConfig.items[verbrauchIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[verbrauchIdx].readonly = istMonats;
                }
                if (this.disableKosten && kostenIdx >= 0 && !formConfig.items[kostenIdx].hidden) {
                    doUpdateState = true;
                    formConfig.items[kostenIdx].hidden = true;
                } else if (!this.disableKosten && kostenIdx >= 0 && formConfig.items[kostenIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[kostenIdx].readonly = istMonats;
                }
                if (co2_emissionenIdx >= 0 && formConfig.items[co2_emissionenIdx].readonly !== istMonats) {
                    doUpdateState = true;
                    formConfig.items[co2_emissionenIdx].readonly = istMonats;
                    if (formValues.energietraeger_tid_orig === 7 /*Ladestrom*/) {
                        // Siehe auch validCo2EmissionenKraftstoffe()
                        let emissionsfaktor: number = getEmissionsFaktorForTid(this.props.data, this.props.jahr, 11); // 11 => Strom in IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER
                        emissionsfaktor = +emissionsfaktor > 0 ? emissionsfaktor * 1000000 : emissionsfaktor;
                        if (emissionsfaktor) {
                            formConfig.items[co2_emissionenIdx].placeholder = emissionsfaktor;
                        } else {
                            formConfig.items[co2_emissionenIdx].required = true;
                        }
                    }
                }

                if (simpleModus) {
                    const hiddenFields = ['abrechnungstage'];
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }

                // Update State
                if (doUpdateState) {
                    this.setState({ formConfig });
                }
            }

            if (entity.entity === IDs.ENT_ENERGIEDATEN_WASSER) {
                let doUpdateState = false;
                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                if (dateiIdx >= 0 && isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = !formValues.tid;
                }
                if (this.disableKosten) {
                    const hiddenFields = ['kosten_abwasser', 'kosten_bezug', 'kosten_niederschlag', 'rueckerstattung'];
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }
                if (simpleModus) {
                    const hiddenFields = ['zaehler_tid'];
                    hiddenFields.forEach((fieldKey: string) => {
                        const idx = formConfig.items.findIndex((i: any) => i.key === fieldKey);
                        if (idx >= 0 && !formConfig.items[idx].hidden) {
                            doUpdateState = true;
                            formConfig.items[idx].hidden = true;
                        }
                    });
                }
                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            if (entity.entity === IDs.ENT_KLIMAGASE) {
                let doUpdateState = false;
                const dateiIdx = formConfig.items.findIndex((i: any) => i.key === 'rechnung');
                if (dateiIdx >= 0 && isInAssisten && formConfig.items[dateiIdx].hidden !== !formValues.tid) {
                    doUpdateState = true;
                    formConfig.items[dateiIdx].hidden = !formValues.tid;
                }
                // Update State
                if (doUpdateState) {
                    updateFormConfig(formConfig);
                }
            }

            showToolBtn = true;
        }
        if (typeof getExtraElement2 === 'function' && formValues) {
            if (entity.entity === IDs.ENT_ENERGIEDATEN_WAERME) {
            }
            showToolBtn2 = true;
        }
        return { showToolBtn, disableToolBtn, showToolBtn2, disableToolBtn2 };
    }

    renderDialog(): JSX.Element {
        const { formValues, showDialog, zaehlerTid, fahrzeugTid, configFahrzeug, standortGruppeTid } = this.state;
        const { data, standort, entity, jahr, onChange, reloadBundle } = this.props;
        if (showDialog === 'editFahrzeug') {
            return (
                <WFormsTableWrapper
                    entity={IDs.ENT_FAHRZEUGE}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{ tid: fahrzeugTid }}
                    showDeleteInSaveDialog
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    callBeforeOnFormSave={(formData: any, callback: () => void) => {
                        if ((data[IDs.ENT_FAHRZEUGE] || []).some((r: any) => r.name === formData.name && r.standort_tid_orig === standort.tid && r.tid !== formData.tid)) {
                            alert('Ein gleichnamiger Datensatz existiert bereits.');
                        } else {
                            callback();
                        }
                    }}
                    onDelDone={(entityName: string, row: any): void => {
                        this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        if ((row || {}).tid) {
                            formValues.fahrzeug_tid = null;
                            formValues.fahrzeug_tid_orig = null;
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                        this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        // Beim Anlegen eines neuen Fahruzeuges wird dieser sofort ausgewählt.
                        console.log('SaveFzg: ', saveTid, formValues);
                        if (saveTid > 0) {
                            formValues.fahrzeug_tid = saveTid;
                            formValues.fahrzeug_tid_orig = saveTid;
                            formValues.fahrzeug_tid_name = values.name;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            if (formValues.standort_tid_orig > 0) {
                                formValues.standort_tid = formValues.standort_tid_orig;
                            } else if (standort.tid > 0) {
                                formValues.standort_tid = standort.tid;
                            }
                            if (formValues.energietraeger_tid_orig > 0) {
                                formValues.energietraeger_tid = formValues.energietraeger_tid_orig;
                            }
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        } else {
                            const valuesOld = this.props.data[IDs.ENT_FAHRZEUGE].find((r: any) => r.tid === values.tid);
                            if (valuesOld.energiedaten_kraftstoff_energietraeger !== values.energiedaten_kraftstoff_energietraeger) {
                                if (typeof onChange === 'function') {
                                    this.setState({ isFormSaveDone: false }, () => {
                                        onChange(entity.entity, formValues, () => {
                                            this.setState({ isFormSaveDone: true });
                                        }, 0);
                                    });
                                }
                            }
                        }
                    }}
                    formPreset={{
                        standort_tid: standort.tid
                    }}
                    customFormConfig={{
                        standort_tid: { readonly: true }
                    }}
                    onAfterAction={(action: string) => {
                        if (action === 'closeForm') {
                            this.setState({ showDialog: null });
                        }
                    }}
                    validateField={(key: string, value: any, data: any, onValueChange) => this.validateField(IDs.ENT_FAHRZEUGE, key, value, data, onValueChange)}
                    hiddenFormFields={configFahrzeug.hiddenFormFields}
                    onFormChange={(WFormData: any) => {
                        const status: number = +WFormData.getValue('status') || null;
                        configFahrzeug.hiddenFormFields = status === 2 ? [] : ['jahr_status'];
                        this.setState({ configFahrzeug });
                    }}
                />
            );
        } else if (showDialog === 'editZaehler' || showDialog === 'editZaehler2') {
            const key: string = showDialog === 'editZaehler2' ? 'zaehler2_tid' : 'zaehler_tid';
            return (
                <WFormsTableWrapper
                    entity={IDs.ENT_ZAEHLER}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{ tid: zaehlerTid }}
                    showDeleteInSaveDialog
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    onDelDone={(entityName: string, row: any): void => {
                        this.triggerService.fire('reload', IDs.ENT_ZAEHLER);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        if ((row || {}).tid) {
                            formValues[key] = null;
                            formValues[`${key}_orig`] = null;
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                        this.triggerService.fire('reload', IDs.ENT_ZAEHLER);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        // Beim Anlegen eines neuen Zählers wird dieser sofort ausgewählt.
                        if (saveTid > 0) {
                            formValues[key] = saveTid;
                            formValues[`${key}_orig`] = saveTid;
                            formValues[`${key}_name`] = values.zaehlernummer;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            if (formValues.standort_tid_orig > 0) {
                                formValues.standort_tid = formValues.standort_tid_orig;
                            } else if (standort.tid > 0) {
                                formValues.standort_tid = standort.tid;
                            }
                            if (formValues.abrechnungsmodus_orig > 0) {
                                formValues.abrechnungsmodus = formValues.abrechnungsmodus_orig;
                            }
                            if (formValues.abrechnungsart_orig > 0) {
                                formValues.abrechnungsart = formValues.abrechnungsart_orig;
                            }
                            if (formValues.seperate_abrechnung_emobil_strom_orig > 0) {
                                formValues.seperate_abrechnung_emobil_strom = formValues.seperate_abrechnung_emobil_strom_orig;
                            }
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    formPreset={{
                        standort: standort.tid,
                        medium: getZaehlerMediumPreset(entity.entity)
                    }}
                    customFormConfig={{
                        standort: { readonly: true },
                        medium: { readonly: true }
                    }}
                    onAfterAction={(action: string) => {
                        if (action === 'closeForm') {
                            this.setState({ showDialog: null });
                        }
                    }}
                    validateField={(key: string, value: any, data: any, onValueChange) =>
                        this.validateField(IDs.ENT_ZAEHLER, key, value, data, onValueChange)}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data) {
                            const fnd = (this.props.data[IDs.ENT_ZAEHLER] || []).find((r: any) => r.tid !== data.tid && r.zaehlernummer === data.zaehlernummer && r.standort_orig === standort.tid);
                            if (fnd) {
                                alert('Ein gleichnamiger Datensatz existiert bereits.');
                                // console.log(fnd);
                                return;
                            }
                        }
                        callback();
                    }}
                />
            );
        } else if (showDialog === 'editKraftstoffeVerbrauch') {
            const energietraegerTid = (formValues || {}).energietraeger_tid_orig;
            const energietraeger = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE}_bundle`] || {}).energietraeger_tid || [])
                .find((item: any) => item.tid === energietraegerTid) || {}).name || '';
            const title = `${jahr}\u00A0\u00A0\u00A0\u00A0\u00A0${standort.name}\u00A0\u00A0\u00A0\u00A0\u00A0${energietraeger}`;

            return <div style={{ width: 780, paddingLeft: 20, position: 'absolute' }}>
                <DialogWrapper2
                    title={title}
                    width={-1}
                    onAfterClose={() => this.setState({ showDialog: null })}
                >
                    <DialogKraftstoffVerbrauch
                        data={this.props.data}
                        standortSelected={standort}
                        jahr={jahr}
                        values={formValues}
                        onChange={(entityName: string, values: any) => {
                            formValues.abrechnungszeitraum_von = values.abrechnungszeitraum_von;
                            formValues.abrechnungszeitraum_bis = values.abrechnungszeitraum_bis;
                            formValues.kosten = values.kosten;
                            formValues.verbrauch = values.verbrauch;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            if (formValues.fahrzeug_tid_orig > 0) {
                                formValues.fahrzeug_tid = formValues.fahrzeug_tid_orig;
                            }
                            // isFormSaveDone wird wieder true beim Update der Elemente.
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }}
                        onClose={() => this.setState({ showDialog: null })}
                        reloadDataMonat={this.props.reloadDataMonat}
                    />
                </DialogWrapper2>
            </div>;
        } else if (showDialog === 'editStandortGruppe') {
            return (
                <WFormsTableWrapper
                    entity={IDs.ENT_STANDORT_GRUPPE}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{ tid: standortGruppeTid }}
                    showDeleteInSaveDialog
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    onDelDone={(entityName: string, row: any): void => {
                        this.triggerService.fire('reload', IDs.ENT_STANDORT_GRUPPE);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        if ((row || {}).tid) {
                            formValues.gruppe = null;
                            formValues.gruppe_orig = null;
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                        this.triggerService.fire('reload', IDs.ENT_STANDORT_GRUPPE);
                        if (reloadBundle) {
                            reloadBundle();
                        }
                        // Beim Anlegen eines neuen Zählers wird dieser sofort ausgewählt.
                        if (saveTid > 0) {
                            formValues.gruppe = saveTid;
                            formValues.gruppe_orig = saveTid;
                            formValues.gruppe_name = values.name;
                            // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                            // if (formValues.standort_tid_orig > 0) {
                            //     formValues.standort_tid = formValues.standort_tid_orig;
                            // }
                            this.setState({ formValues });
                            if (typeof onChange === 'function') {
                                this.setState({ isFormSaveDone: false }, () => {
                                    onChange(entity.entity, formValues, () => {
                                        this.setState({ isFormSaveDone: true });
                                    }, 0);
                                });
                            }
                        }
                    }}
                    onAfterAction={(action: string) => {
                        if (action === 'closeForm') {
                            this.setState({ showDialog: null });
                        }
                    }}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data) {
                            const fnd = (this.props.data[IDs.ENT_STANDORT_GRUPPE] || []).find((r: any) => r.tid !== data.tid && r.name === data.name);
                            if (fnd) {
                                alert('Ein gleichnamiger Datensatz existiert bereits.');
                                // console.log(fnd);
                                return;
                            }
                        }
                        callback();
                    }}
                />
            );
        }
    }

    validateField(entity: string, key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        let category: string = null;
        let inputOnly: boolean = false;
        let type: string = null;
        const field: string = validateFieldUniversal(
            entity, key, value, data, onValueChange, this.props.data,
            (info: any) => {
                category = (info || {}).category || null;
                inputOnly = !!(info || {}).inputOnly;
                type = (info || {}).type || null;
            }
        );
        const values: any = data.values || {};
        const tid: number = +values.tid || null;

        Object.keys(this.required).forEach((key2: string) => {
            const value2: any = values[key2];

            if (
                tid
                && (typeof value2 === 'undefined' || value2 === null || value2 === ''
                    || ((this.required[key2] || {}).type === 'select' && value2 == 0)
                )
                && Object.keys(this.required).indexOf(key2) !== -1
            ) {
                const isException: boolean = (entity === IDs.ENT_BETRIEBSDATEN);
                // || (
                //     entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && key2 === 'kosten' && values.kosten === null
                //     && values.verbrauch !== null
                // )
                // || (
                //     entity === IDs.ENT_ENERGIEDATEN_WASSER && key2 === 'kosten_bezug' && values.kosten_bezug === null
                //     && values.fremdbezug !== null
                // );
                this.validation[key2] = {
                    text: [`Bitte Feld '${this.required[key2].name || ''}' ausfüllen`],
                    type: isException ? 'warning' : 'error'
                };
            } else if (!tid) {
                this.validation[key2] = null;
            }
        });

        if (tid && !inputOnly) {
            this.validation[key] = field
                ? {
                    text: (field || '').toString().split('\n').map((line: string) => line),
                    ...(category && { category }),
                    ...(type && { type })
                }
                : null;
        } else {
            this.validation[key] = null;
        }

        if (typeof this.props.onValidate === 'function') {
            this.props.onValidate({
                entity,
                jahr: this.props.jahr,
                tid,
                fields: this.validation
            });
        }

        return field;
    }

    getFormEventHandler(key: string) {
        // WKETOOL-113: 189 Im Dropdown soll es möglich sein, eine initiale Option hinzuzufügen
        if (key === 'fahrzeug_tid') {
            return {
                onMenuOpen: (params?: any) => {
                    const bundle = (params || {}).bundleData;
                    // console.log(bundle);
                    if (Array.isArray(bundle) && bundle.length === 0) {
                        setTimeout(() => this.setState({ showDialog: 'editFahrzeug', fahrzeugTid: 0 }), 100);
                    }
                }
            };
        } else if (key === 'zaehler_tid') {
            return {
                onMenuOpen: (params?: any) => {
                    const bundle = (params || {}).bundleData;
                    // console.log(bundle);
                    if (Array.isArray(bundle) && bundle.length === 0) {
                        setTimeout(() => this.setState({ showDialog: 'editZaehler', zaehlerTid: 0 }), 100);
                    }
                }
            };
        } else if (key === 'standortGruppe_tid') {
            return {
                onMenuOpen: (params?: any) => {
                    const bundle = (params || {}).bundleData;
                    // console.log(bundle);
                    if (Array.isArray(bundle) && bundle.length === 0) {
                        setTimeout(() => this.setState({ showDialog: 'editStandortGruppe', standortGruppeTid: 0 }), 100);
                    }
                }
            };
        } else if (key === 'addTochtergesellschaft') {
            return {
                onMenuOpen: (params?: any) => {
                    const bundle = (params || {}).bundleData;
                    if (Array.isArray(bundle) && bundle.length === 0) {
                        setTimeout(() => this.setState({ showDialog: 'addTochtergesellschaft' }), 100);
                    }
                }
            };
        }
    }
}
